import LogoSherpa from './LogoSherpa'

export default LogoSherpa
// eslint-disable-next-line import/export
export * from './LogoSherpa'
